import React from 'react';
import PropTypes from 'prop-types';
import { SpinnerBox } from './styles';
import { themeColor } from '../../layout/global-style';

export const Spinner = ({
  isLoading = false, color = themeColor.black, hoverColor = themeColor.red, className
}) => (
  <>
    { isLoading ? (
      <SpinnerBox
        color={color}
        hoverColor={hoverColor}
        className={className}
      />
    ) : null }
  </>
);

Spinner.propTypes = {
  isLoading: PropTypes.bool,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  className: PropTypes.string,
};

Spinner.defaultProps = {
  isLoading: false,
  color: themeColor.black,
  hoverColor: themeColor.red,
  className: undefined
};

export default Spinner;
